import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { faStar } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.scss']
,  standalone: false
})
export class RatingComponent implements OnInit {
    @Input() numberOfStars: number = 0;
    @Output() userRating: EventEmitter<number> = new EventEmitter();

    faStar = faStar;
    stars: number[] = [];
    selectedValue: number;

    ngOnInit() {
        for (let i = 1; i <= this.numberOfStars; i++) {            
            this.stars.push(i);
        }
        
    }
    countStar(star) {
        this.selectedValue = star;        
        this.userRating.emit(this.selectedValue);
    }

}
